import constants from '@/app/competitive/constants';

export function formatCompetitor(sourceData, source) {
  if (!sourceData) {
    return null;
  }

  switch (source) {
    case constants.competitiveSources.INSTAGRAM:
      return {
        handle: sourceData.handle,
        label: sourceData.handle,
        avatar: sourceData.avatarUrl,
        value: `${sourceData.instagramId}`,
      };
    case constants.competitiveSources.TWITTER:
      return {
        handle: sourceData.handle,
        label: sourceData.handle,
        avatar: sourceData.twitterAvatar,
        value: sourceData.twitterUserId,
      };
    case constants.competitiveSources.YOUTUBE:
      return {
        handle: sourceData.title,
        label: sourceData.title,
        avatar: sourceData.thumbnailUrl,
        value: sourceData.sourceChannelId,
      };
    case constants.competitiveSources.FACEBOOK:
      return {
        handle: sourceData.name,
        label: sourceData.name,
        avatar: sourceData.avatar,
        value: sourceData.fbPageId,
      };
    case constants.competitiveSources.TIKTOK:
      return {
        handle: sourceData.handleName,
        label: sourceData.handleName,
        avatar: sourceData.profileImage,
        value: sourceData.internalCreatorId,
      };
    default:
      throw new Error(`Unrecognized source "${source}"!`);
  }
}

export function formatSegmentCluster(data) {
  return formatCompetitor(data.sourceData, data.targetSource);
}
